import { render, staticRenderFns } from "./PaymentMethodDialog.vue?vue&type=template&id=826e8960&scoped=true&"
import script from "./PaymentMethodDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodDialog.vue?vue&type=style&index=0&id=826e8960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e8960",
  null
  
)

export default component.exports